import React from 'react'
import HeaderFour from '../header/HeaderFour';
import Breadcrumb from '../inner/Breadcrumb';
// import ServiceFive from '../elements/ServiceFive';
import WorkingProcessThree from '../elements/WorkingProcessThree';
import Team from '../elements/Team';
import TestimonialsBrand from '../elements/TestimonialsBrand';
import Footer from '../elements/Footer';
import ServiceFIve from '../elements/ServiceFIve';
import HeaderNew from '../header/HeaderNew';





function Service() {
    return (

        <div className="">
            <HeaderNew/>
            <main>
                {/* Start Breadcrumb area  */}
                {/* <div className="breadcrumb-area bg_image tmp-section-gap"
                style={{backgroundImage: `url(assets/images/breadcrumb/service.webp)`}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="breadcrumb-inner text-center">
                                    <h1 className="title split-collab">Service Us</h1>
                                    <ul className="page-list">
                                        <li className="tmp-breadcrumb-item">
                                            <a href="/">Home</a>
                                        </li>
                                        <li className="icon">
                                            <i className="fa-solid fa-angle-right" />
                                        </li>
                                        <li className="tmp-breadcrumb-item active">Service</li>
                                    </ul>
                                    <div className="circle-1" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Breadcrumb area  */}

                {/* <ServiceFive /> */}
                <ServiceFIve/>
                <Footer />

            </main>
        </div>
    )
}

export default Service